import React from 'react';
import { usePopupManager, useShowContextRequired } from 'ui-builder';
import { ConfirmDeletePopup, IconButton, IconType } from 'features/nekst-widgets';
import { DocumentLabel, useDocumentLabelsService } from 'nekst-api';

function ConfirmDeleteLabelPopup(props: {
  data: DocumentLabel,
}) {
  const service = useDocumentLabelsService();
  return (
    <ConfirmDeletePopup
      deleteFunc={() => service.deleteLabel(props.data.id)}
      message={
        `Are you sure you want to delete label "${props.data.name}"? It will be deleted from all transactions and templates`
      }
    />
  );
}

export default function DeleteLabelButton() {

  const showContext = useShowContextRequired<DocumentLabel>();
  const popupManager = usePopupManager();
  return (
    <IconButton
      type={IconType.TRASH_CAN}
      onClick={() => popupManager.openPopup(<ConfirmDeleteLabelPopup data={showContext.data} />)}
      title="Delete Label"
    />
  );
}
